import { useSelector } from 'react-redux'
import { platformSettingsSlice } from '@wellesley/settings/slices/platformSettingsSlice'
import { AppsRoutes } from '@wellesley/router'
import { PropsWithChildren, useEffect } from 'react'
import { authSlice } from '../../authSlice'
import { matchPath, useLocation, useNavigate } from 'react-router-dom'

const whiteList: AppsRoutes[] = [
  '/about',
  '/terms',
  '/privacy',
  '/forgot-password',
  '/signin',
  '/signup',
  '/signup/:inviteCode',
  '/signup/update-username/:hash',
]

const isWhiteList = (url: string) => {
  return whiteList.some((route) => matchPath(route, url))
}
export const ProtectPrivateServer = ({ children }: PropsWithChildren) => {
  const location = useLocation()
  const navigate = useNavigate()

  const isAuthenticated = useSelector(authSlice.selectors.selectIsAuthenticated)
  const isPending = useSelector(authSlice.selectors.selectPending)
  const { visibility } =
    useSelector(platformSettingsSlice.selectors.selectAccess) || {}

  useEffect(() => {
    if (
      visibility === 'PRIVATE' &&
      !isAuthenticated &&
      !isPending &&
      !isWhiteList(location.pathname)
    ) {
      navigate('/signin')
    }
  }, [visibility, isAuthenticated, isPending, location.pathname])

  return visibility ? <>{children}</> : null
}
